import { useLazyQuery } from '@apollo/client'
import { setAlertQueue } from 'cache/alerts'
import { getLatestDeal, setEmailContentVersion } from 'cache/latest-deal-info'
import errorMessages from 'constants/errorMessages'
import { GET_EMAIL_CONTENT } from 'queries/get-email-content'
import { MessageType } from 'ts/enums/messageType.enums'

interface DecisionEmailResponse {
  decisionEmail: {
    emailBody: string
    isDealUpdated: boolean
    emailTemplateId: number
    dealId: number
    didError: boolean
    errorMessage: string | null
    __typename: string
  }
}

interface DecisionEmailRequest {
  input: {
    dealId: number
    emailId: string
  }
}

export const useGetDecisionEmail = () => {
  const dealData = getLatestDeal()
  const [getDecisionEmail, { data, loading, error }] = useLazyQuery<
    DecisionEmailResponse,
    DecisionEmailRequest
  >(GET_EMAIL_CONTENT, {
    fetchPolicy: 'no-cache',
    onCompleted: (data) => {
      if (data?.decisionEmail?.didError) {
        console.error('Error fetching decision email:', data.decisionEmail.errorMessage)
      }
      if (data.decisionEmail.isDealUpdated) {
        setAlertQueue({ type: MessageType.WARNING, message: errorMessages.DATA_HAS_BEEN_CHANGED })
      }
      if (data?.decisionEmail?.dealId) {
        setEmailContentVersion(data.decisionEmail.dealId)
      }
      if (data.decisionEmail?.dealId !== dealData?.dealId) {
        setAlertQueue({ type: MessageType.WARNING, message: errorMessages.DEAL_VERSIONED_UP })
      }
    },
  })

  return {
    getDecisionEmail,
    data: data?.decisionEmail,
    loading,
    error,
    versionStatus: data?.decisionEmail?.dealId,
  }
}
